import React from 'react';

export default function BlogImageDuo({ data }) {
  const { images } = data;
  if (!images || images.length < 2) return null;

  return (
    <div className="blog-image-duo">
      {images.slice(0, 2).map((img, i) => (
        <div key={i} className="blog-image-duo-item">
          <img src={img.src} alt={img.alt || ''} />
        </div>
      ))}
    </div>
  );
}
